import { render, staticRenderFns } from "./CheckProtocol.vue?vue&type=template&id=1e352c84&scoped=true&"
import script from "./CheckProtocol.vue?vue&type=script&lang=ts&"
export * from "./CheckProtocol.vue?vue&type=script&lang=ts&"
import style0 from "./CheckProtocol.vue?vue&type=style&index=0&id=1e352c84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e352c84",
  null
  
)

export default component.exports